// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"dc07da49","442":"6ffd03b9","723":"5b556527"}[chunkId] + ".chunk.css";
};